import React from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

interface SponsorStatusBadgeProps {
  active: boolean;
  className?: string;
  size?: 'sm' | 'md';
}

export default function SponsorStatusBadge({
  active,
  className,
  size = 'sm',
}: SponsorStatusBadgeProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <span
      className={twMerge(
        'inline-flex flex-shrink-0 items-center rounded-full font-semibold',
        size === 'sm' ? 'px-2.5 py-0.5 text-xs' : 'px-3 py-1 text-xs',
        active ? 'bg-primary-100 text-primary-900' : 'bg-secondary-200 text-primary-900',
        className,
      )}>
      {t(active ? 'page.sponsors.statusActive' : 'page.sponsors.statusInactive')}
    </span>
  );
}
